import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import browser from 'Cloud/browser';

export const isWopiForSafari = browser.isSafari() ? isFeature('wopi-safari') : true;
export const isWopiEnabled = isWopiForSafari && isFeature('wopi');
export const isWopiOldEnabled = isWopiForSafari && isFeature('wopi-old');

export const expFormats = isWopiForSafari && getFeature('myoffice-exp-formats');

export const attachTextFormats = getFeature('attach-text-formats') ?? [];

export const wopiFallbackConfig =
    isWopiForSafari &&
    (getFeature('wopi-fallback-config') || {
        hostReg: '^https:\\/\\/(?:docs\\-mo|docs\\-myoffice)\\.datacloudmail\\.ru',
        enableFallback: false,
        enableFallbackServiceError: false,
        enableTimeoutFallback: false,
        enableFallbackPostMsgError: false,
    });

export const wopiJsErrorsFallbackList = isWopiForSafari && (getFeature('wopi-js-errors-fallback-list') || []);
// Время фолбека для переключения с WOPI на AMR в секундах
export const wopiTimeoutFallbackTimeSec = isWopiForSafari && getFeature('wopi-timeout-fallback-time-sec');
export const isHashCalcLibWasm = getFeature('hash-lib')?.isWasm ?? 0;
export const isHashCalcLibCrypto = (getFeature('hash-lib')?.isCrypto && typeof window?.crypto?.subtle?.digest === 'function') ?? 0;
export const isDmrReactUrlEnabled = isFeature('ab-dmr-react');
// DMR для реакт окна присылает неверную высоту, пока делаем коррекцию этого у себя
export const abReactDmrHeightFix = getFeature('ab-dmr-react')?.heightFix ?? 0;

// tempexp_SRCH-70037 start
export const isNewWebSearchBackendEnabled = isFeature('new_search_by_content');
// tempexp_SRCH-70037 end
// tempexp_SRCH-70925 start
export const isNewTouchSearchBackendEnabled = isFeature('new_search_by_content_touch');
// tempexp_SRCH-70925 end
export const isNewWebSearchUIEnabled: boolean = isFeature('new_search_UI');
export const isTouchSearchEnabled = isFeature('new_search_UI_touch');

// tempexp_SRCH-70994 start
export const isNewWebSearchHistoryEnabled = isNewWebSearchUIEnabled && isFeature('new_search_query_history_web');
// tempexp_SRCH-70994 end
// tempexp_SRCH-70997 start
export const isTouchSearchHistoryEnabled = isTouchSearchEnabled && isFeature('new_search_query_history_touch');
// tempexp_SRCH-70997 end

export const ebookDesktopConfig:
    | {
          exts: string[];
          timeout: number;
      }
    | undefined = getFeature('ebook-desktop-config');
export const ebookTouchConfig: typeof ebookDesktopConfig = getFeature('ebook-touch-config');
// tempexp_14979-start
export const isHideQuotaNewbieFeatureEnabled = isFeature('hide-quota-newbie');
// Нужно тестировать разную дефолную квоту до начала экспа. Поэтому мокаем через фичу.
export const defaultQuotaValueMockForQA = getFeature('default-quota-mock-qa') || false;
// tempexp_14979-end
/** CLOUDWEB-14535: ЕК. Фильтр по годам. Shift лет назад от текущего года для старых групп */
export const quotaCleanerOldGroupYear = getFeature('quota-cleaner-old-group-year') || 0;
/** CLOUDWEB-14948 Аб: Новый лп Единой квоты/страница подписок на таче */
export const isFeatureAbQuotaLandingTouch = getFeature('ab-quota-landing-touch') === 'b';
/** CLOUDWEB-14877 Ovidius fallback */
export const isOvidiusFallback = isFeature('ovidius-fallback');
